<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AMxk7F/tc-custom/9781473846739.jpg?1702526160698" alt="This image is the cover for the book War in Ancient Greece, Military History from Primary Sources"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">War in Ancient Greece, Military History from Primary Sources
      </h1>
      <p class="bookDescription body article font2">
        <p>The Athenian Thucydides (c490-395BC) wrote this history of the Peloponnesian War between the Spartans and the Athenians, believing that it would be a greater war than any that had preceded it, and his version of events would serve as a possession for all time.The fragmentary nature of ancient Greece increased the frequency of conflict, but conversely limited the scale of warfare. Unable to maintain professional armies, the city-states relied on their own citizens to fight, reducing the potential duration of campaigns. The rise of Athens and Sparta as preeminent powers, however, led directly to the Peloponnesian War, which saw further development of the nature of warfare, strategy and tactics. Fought between leagues of cities dominated by Athens and Sparta, the increased manpower and financial resources increased the scale, and allowed the diversification of warfare. Set-piece battles during the Peloponnesian war proved indecisive and instead there was increased reliance on attritionary strategies, naval battle and blockades and sieges.This book is essential reading for anyone interested the military history of the classical world.As seen in All About History Magazine.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Carruthers
      </h2>
      
      <p class="authorDescription body article">Bob Carruthers is an Emmy Award winning author and historian, who has written extensively on the Great War. A graduate of Edinburgh University, Bob is the author of a number of military history titles including the Amazon bestseller <I>The Wehrmacht in Russia</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18f538a2